<template>
    <div class="row">
        <label :for="id" class="col-md-2 col-form-label">
            {{title}}
            <span class="color-red">*</span>
        </label>
        <div class="col-md-5">
            <el-autocomplete
                    :id="id"
                    class="form-control"
                    v-model="value.value"
                    :fetch-suggestions="querySearch"
                    placeholder=""
                    @select="handleSelect"
            />
            <input type="hidden" :name="name" :value="locationId" required>
        </div>
    </div>

</template>

<script>
  export default {
    name: 'Location',
    props: {
      id: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      defaultValue: {
        type: null,
        required: false
      },
      title: {
        type: String,
        required: true
      }
    },
    data: function () {
      return {
        stringValue: '',
        value: {},
        locationId: 0
      }
    },
    watch: {
      defaultValue: function () {
        this.update()
      },
      value: function () {
        this.locationId = this.value.ID
      }
    },
    created: function () {
      this.update()
    },
    methods: {
      querySearch (queryString, cb) {
        let params = new FormData()
        params.append('QUERY', queryString)
        params.append('LIMIT', '50')
        params.append('PAGE', '0')
        this.$http.post('/local/components/sb/sale.location.selector.search/get.php', params).then(response => {
          let data = response.data.data['ITEMS']
          data.map(item => {
            item.value = item.DISPLAY
            return item
          })
          cb(response.data.data['ITEMS'])
        })
      },
      handleSelect (item) {
        this.value = item
      },
      update () {
        let params = new FormData()
        params.append('CODE', '' + this.defaultValue)
        this.$http.post('/local/components/sb/sale.location.selector.search/get.php', params).then(response => {
          let data = response.data.data['ITEMS']
          data.map(item => {
            item.value = item.DISPLAY
            return item
          })
          console.log(data)
          if (data.length > 0) {
            this.value = data[0]
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/components/userProfiles/components/location.vue